import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  LOAN_DETAIL_CHANGED,
  UPDATE_COMMITMENTS_SUCCESS,
  UPDATE_ASSETS_SUCCESS,
  UPDATE_LOAN_DETAIL_SUCCESS,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
} from '../../actions/types'

const INIT_STATE = {
  variableRepaymentType: 'principal_and_interest',
  variableInterestPeriod: '1',
}

const prefilledState = (newState) => {
  const variableRepaymentType = newState.variableRepaymentType || INIT_STATE.variableRepaymentType
  const variableInterestPeriod = newState.variableInterestPeriod || INIT_STATE.variableInterestPeriod

  return {
    variableRepaymentType,
    variableInterestPeriod,
  }
}

const variableRate = (state = INIT_STATE, {type, payload}) => {
  switch (type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      if (payload.applicationFlow.loanDetail !== undefined ) {
        const newState = payload.applicationFlow.loanDetail.variable
        return prefilledState(newState)
      } else {
        return state
      }

    case UPDATE_COMMITMENTS_SUCCESS:
    case UPDATE_ASSETS_SUCCESS:
    case UPDATE_LOAN_DETAIL_SUCCESS:
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      if (payload.loanDetail !== undefined) {
        return prefilledState(payload.loanDetail.variable)
      } else {
        return state
      }

    case LOAN_DETAIL_CHANGED:
      return { ...state, ...payload.variable }
    default:
      return state;
  }
}

export default variableRate;
